import "./styles/css/navbar.min.css";
import "./styles/css/utilities.min.css";
import "./styles/css/contact.min.css";
import "./styles/css/about.min.css";
import "./styles/css/sectionimage.min.css";
import "./styles/css/blog.min.css";
import "./styles/css/kegiatan.min.css";
import "./styles/css/footer.min.css";
import "./styles/css/section-breadcrumb.min.css";
import "react-toastify/dist/ReactToastify.css";

import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { FooterAlt, FooterList } from "./layouts/footer";
import NavbarHeader from "./layouts/navbar";

import {
    LandingPageHome,
    DetailBlogContent,
    DetailKegiatanContent,
    DetailAboutContent,
} from "./pages";
import { ToastContainer } from "react-toastify";

function App() {
    return (
        <Router>
            <div className="App">
                <NavbarHeader />
                <ToastContainer />
                <Routes>
                    <Route axact path="/" element={<LandingPageHome />}></Route>
                    <Route
                        axact
                        path="/Blog/:id"
                        element={<DetailBlogContent />}
                    ></Route>
                    <Route
                        axact
                        path="/Kegiatan/:id"
                        element={<DetailKegiatanContent />}
                    ></Route>
                    <Route
                        axact
                        path="/About"
                        element={<DetailAboutContent />}
                    ></Route>
                </Routes>
                <FooterList />
                <FooterAlt />
            </div>
        </Router>
    );
}

export default App;
